import React from 'react';
import { securityItems } from '../../data/homeContent';

function HomeSecurity() {
  return (
    <section className="home-section home-security">
      <div className="container">
        <div className="home-section-head">
          <p className="home-kicker">ENTERPRISE-GRADE SECURITY</p>
          <h2>School data protected to a serious standard</h2>
          <p className="home-lead">
            Encryption, backups, roles, and multi-factor access — so leadership can move fast without losing control of records.
          </p>
        </div>
        <div className="home-card-grid home-security-grid">
          {securityItems.map((item, index) => (
            <article key={item.title} className={`home-card home-card-lite home-card-tone-${index + 1}`}>
              <span className="home-card-index">0{index + 1}</span>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HomeSecurity;
